'use-strict';

import angular from 'angular';

/* @ngInject */
export default function routing(
  $routeProvider: angular.route.IRouteProvider,
  $locationProvider: angular.ILocationProvider,
  $httpProvider: angular.IHttpProvider,
): void {
  // $locationProvider.html5Mode(true);

  $routeProvider
    .otherwise({
      redirectTo: '/page-not-found',
    });

  // Handle Situation when token is no longer valid, and api calls get rejected
  $httpProvider.interceptors.push(($q) => {
    'ngInject';

    return {
      responseError(rejection) {
        const defer = $q.defer();
        defer.reject(rejection);
        return defer.promise;
      },
    };
  });
}
